// ERSTER Import: zentrale moment-Locale (de, Montag-Wochenstart) — muss vor
// jedem moment-Consumer geladen sein (Kalender-Wochenansicht, SP1).
import './utils/momentDe';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/scrollHinweis.css';
import App from './App';
import { installPerfProbe } from './utils/perfNetworkProbe';
import { installPushDiagnostics } from './services/pushDiagnostics';
import { installiereTicketSpuren } from './components/tickets/ticketSpuren';
import { installiereScrollHinweise } from './hooks/useScrollHinweis';
import { installiereIosKeinEingabeZoom } from './utils/iosKeinEingabeZoom';

// Opt-in Netzwerk-Mess-Probe (No-op ohne Flag): localStorage KMVS_PERF=1 oder ?perf=1.
// Siehe docs/performance/frontend-netzwerk-analyse.md.
installPerfProbe();
// Ringpuffer für Tickets: letzte Konsolenfehler + fehlgeschlagene API-Aufrufe.
installiereTicketSpuren();
// iPhone/iPad: kein automatisches Heranzoomen beim Tippen in ein Feld.
installiereIosKeinEingabeZoom();

// Workaround für den Chrome/ResizeObserver-Fehler, der u.a. bei Dropdowns auftreten kann
const isResizeObserverError = (message: string | undefined) =>
  !!message && message.includes('ResizeObserver loop completed with undelivered notifications.');

window.addEventListener('error', (event) => {
  if (isResizeObserverError(event.message)) {
    event.stopImmediatePropagation();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = (event as PromiseRejectionEvent).reason;
  const message = reason?.message ?? (typeof reason === 'string' ? reason : undefined);
  if (isResizeObserverError(message)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// (CRA webpack-dev-server overlay suppression removed — Vite uses its own overlay)

// Service Worker für Web-Push (Browser-/OS-Benachrichtigungen) registrieren.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Bisher still verschluckt: schlägt die Registrierung fehl (kein HTTPS,
      // /sw.js nicht ausgeliefert), gibt es keine einzige Browser-Push — ohne
      // jede Spur. Ab jetzt steht der Grund in der Konsole.
      console.error('[KMVS] Service Worker (/sw.js) konnte nicht registriert werden — Browser-Benachrichtigungen sind damit unmöglich:', err);
    });
  });
}

// Lange Auswahllisten zeigen „Weitere Optionen — scrollen" (hooks/useScrollHinweis.ts).
installiereScrollHinweise();

// Selbstdiagnose für Benachrichtigungen: stellt `kmvsPush` in der Konsole bereit.
installPushDiagnostics();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
